// import * as React from "react";
// import Box from "@mui/material/Box";
// import { Fab, Grid, Typography } from "@mui/material";
// import { useNavigate } from "react-router";
// import config from "config";
// import { useState } from "react";
// import { AppBarTextColor } from "utils/ui-constants/UIConst";
// import { MenuSet } from "store/hiredrateAppSet";
// import HiredrateSettingDropDown from "./HiredrateSettingDropDown";
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import PostAddIcon from "@mui/icons-material/PostAdd";
// import QueryStatsIcon from "@mui/icons-material/QueryStats";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import Joyride from 'react-joyride';
// import { useDispatch, useSelector } from "react-redux";
// import { MENU_SELECT, TOUR_LOCATION } from "store/actions";
// import { useTheme } from "@mui/styles";
// import { IconBriefcase, IconChartHistogram, IconUsers } from "@tabler/icons";

// const HiredrateAppBar = ({ highlightMenu, handleTopMenuClick, runTour, setRunValue }) => {
//   const [anchorAl, setAnchorAl] = useState(MenuSet[0]);
//   const { menuItem } = useSelector((state) => state.account);
//   const { tourLocation }= useSelector((state) => state.customization);
//   const dispatcher = useDispatch();
//   const navigate = useNavigate();
//   const [tourSteps, setTourSteps] = useState([]);
//   const [isTourOpen, setIsTourOpen] = useState(runTour === 1);

//   // Define steps for the tour
//   React.useEffect(() => {
//     setTourSteps([
      
//       // {
//       //   target: '.job-positions-menu',
//       //   content: 'Here you can manage job positions.',
//       //   placement: 'bottom'
//       // },
//       // {
//       //   target: '.job-positions-menu',
//       //   content: (
//       //     <div>
//       //       <p>Here you can manage job positions.</p>
//       //       <button
//       //         onClick={handleCreateJobPosition}
//       //         style={{
//       //           padding: '8px 16px',
//       //           backgroundColor: '#1976d2',
//       //           color: 'white',
//       //           border: 'none',
//       //           borderRadius: '4px',
//       //           cursor: 'pointer',
//       //           marginTop: '8px',
//       //         }}
//       //       >
//       //         Create Job Position
//       //       </button>
//       //     </div>
//       //   ),
//       //   placement: 'bottom'
//       // },
//       {
//         target: '.applications-menu',
//         content: 'View and manage job applications here.',
//         placement: 'bottom'
//       },
//       {
//         target: '.match-analysis-menu',
//         content: 'Analyze your job matches here.',
//         placement: 'bottom'
//       },
//       {
//         target: '.dashboard-menu',
//         content: 'This is your Dashboard where you can get an overview of everything.',
//         placement: 'bottom'
//       },
//       // {
//       //   target: '.match-analysis-menu',
//       //   content: 'Analyze your job matches here.',
//       //   placement: 'bottom'
//       // }
//     ]);
//   }, []);

//   const handleMenuClick = (val) => {
//     handleTopMenuClick();
//     setAnchorAl(val);
//     if (val === "Dashboard") {
//       navigate("/dashboard/default");
//     } else if (val === "Job Positions List") {
//     } else if (val === "Applications") {
//       navigate("/ap/job-applicants");
//     } else if (val === "Match Analysis") {
//       navigate("/ma/match-analysis");
//     } else {
//       navigate("/jp/job-positions");
//     }
//     dispatcher({
//       type: MENU_SELECT,
//       payload: {
//         menuItem: val,
//       },
//     });
//   };

//   const handleCreateJobPosition = () => {
//     navigate("/jp/job-positions");
//     setIsTourOpen(false);
//     if (setRunValue) {
//       setRunValue(0); // Reset the run value
//     }
//   };

//   const handleTourEnd = ({ status, index }) => {
//     console.log('indexindexindex',index);
//     if (index == 0) {
//       navigate("/ap/job-applicants");
//     }
//     if (index == 1) {
//       navigate("/ma/match-analysis");
//     }
//     if (index == 2) {
//       navigate("/dashboard/default");
//     }
//     if (index == 3) {
//         dispatcher({
//           type: TOUR_LOCATION,
//           payload: {
//             tourLocation: 0,
//           },
//         });
//       navigate("/jp/job-positions");
//     }
//   };

//   const theme = useTheme();

//   React.useEffect(() => {
//     if (runTour === 1) {
//       setIsTourOpen(true);
//     }
//   }, [runTour]);

//   return (
//     <>
//       {tourLocation == 6 && (
//         <Joyride
//           steps={tourSteps}
//           continuous={true}
//           showSkipButton={true}
//           styles={{
//             options: {
//               zIndex: 10000,
//             },
//             buttonNext: {
//               backgroundColor: theme.palette.primary.light,
//               color: theme.palette.primary.contrastText,
//               borderRadius: '5px',
//               padding: '10px 10px',
//             },
//             buttonBack: {
//               marginRight: 10,
//               backgroundColor: theme.palette.secondary.main,
//               color: theme.palette.secondary.contrastText,
//               borderRadius: '5px',
//               padding: '10px 10px',
//             },
//             buttonClose: {
//               marginTop: 3,
//               marginRight: 3,
//               backgroundColor: 'transparent', // No background for outlined
//               color: theme.palette.error.main, // Primary color for text
//               borderRadius: '5px',
//               padding: '1px 2px',
//               border: `1px solid ${theme.palette.error.main}`, // Primary color border
//               '&:hover': {
//                 backgroundColor: theme.palette.action.hover, // Subtle hover effect
//               },
//             },
//           }}
//           locale={{
//             back: 'PREVIOUS',
//             next: 'CONTNUE',
//             last: 'END TOUR'
//           }}
//           callback={handleTourEnd}
//         />
//       )}
//       <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
//         {MenuSet.map((page) => (
//           <Grid item sx={{mr:3}} key={page}>
//             {page !== 'Settings' && page !== 'Job Positions List' ?
//              <Fab
//               variant="extended"
//               size="small"
//               sx={{
//                 backgroundColor: "transparent",
//                 boxShadow: "none",
//                 my: 1,
//                 color: theme.palette.common.black,
//                 display: "block",
//                 ml: 1,
//                 textTransform: "uppercase",
//                 fontWeight: "bold",
//               }}
//               onClick={() => handleMenuClick(page)}
//               className={`${page.toLowerCase().replace(/\s+/g, '-')}-menu`} // Adding class names for targeting
//             >
//               {menuItem === page ? (
//                 <Typography
//                   color={AppBarTextColor().selectColor}
//                   textAlign="center"
//                   variant="h5"
//                   fontWeight={"bold"}
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     height: '100%',
//                     gap: 1
//                   }}
//                 >
//                   {page === 'Job Positions' ? <IconBriefcase sx={{ fontSize: 22, mr: .5 }}/>:null} 
//                   {page === 'Applications' ? <IconUsers sx={{ fontSize: 22, mr: .5 }}/>:null} 
//                   {page === 'Match Analysis' ? <IconChartHistogram sx={{ fontSize: 22, mr: 2 }}/>:null} 
//                   {page === 'Dashboard' ? <DashboardIcon sx={{ fontSize: 22, mr: .5 }}/>:null} 
//                   {page}
//                 </Typography>
//               ) : (
//                 <Typography textAlign="center" variant="h5" fontWeight={"bold"}
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1
//                 }}>
//                   {page === 'Job Positions' ? <IconBriefcase sx={{ fontSize: 22, mr: 2 }}/>:null} 
//                   {page === 'Applications' ? <IconUsers sx={{ fontSize: 22, mr: .5 }}/>:null} 
//                   {page === 'Match Analysis' ? <IconChartHistogram sx={{ fontSize: 22, mr: 4 }}/>:null} 
//                   {page === 'Dashboard' ? <DashboardIcon sx={{ fontSize: 22, mr: .5 }}/>:null} 
//                   {page}
//                 </Typography>
//               )}
//             </Fab>
//             : 
//             page === 'Settings' ?
//              <HiredrateSettingDropDown
//               keyName={page} selectMenu={anchorAl} selectTrigger={(eve) => {
//                 if (eve !== 'NS') { handleMenuClick(page)}
//               }}/>
//               : null
//           }
//           </Grid>
//         ))}
//       </Box>
//     </>
//   );
// }

// export default HiredrateAppBar;

import * as React from "react";
import Box from "@mui/material/Box";
import { Fab, Grid, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router";
import { useState } from "react";
import { AppBarTextColor } from "utils/ui-constants/UIConst";
import { MenuSet } from "store/hiredrateAppSet";
import HiredrateSettingDropDown from "./HiredrateSettingDropDown";
import DashboardIcon from '@mui/icons-material/Dashboard';
import Joyride from 'react-joyride';
import { useDispatch, useSelector } from "react-redux";
import { MENU_SELECT, TOUR_LOCATION } from "store/actions";
import { useTheme } from "@mui/styles";
import {
  IconBriefcase,
  IconChartHistogram,
  IconUsers,
} from "@tabler/icons";
import { IconMenuDeep } from '@tabler/icons-react';

const HiredrateAppBar = ({ highlightMenu, handleTopMenuClick, runTour, setRunValue }) => {
  const [anchorAl, setAnchorAl] = useState(MenuSet[0]);
  const { menuItem } = useSelector((state) => state.account);
  const { tourLocation } = useSelector((state) => state.customization);
  const dispatcher = useDispatch();
  const navigate = useNavigate();
  const [tourSteps, setTourSteps] = useState([]);
  const [isTourOpen, setIsTourOpen] = useState(runTour === 1);

  /** 🔹 Deep menu state */
  const [deepMenuAnchor, setDeepMenuAnchor] = useState(null);

  const hiddenMenus = ["Job Positions", "Applications", "Match Analysis"];

  const theme = useTheme();

  React.useEffect(() => {
    setTourSteps([
      {
        target: '.menu-deep',
        content: 'Access Job Positions, Applications and Match Analysis from here.',
        placement: 'bottom'
      },
      {
        target: '.dashboard-menu',
        content: 'This is your Dashboard overview.',
        placement: 'bottom'
      }
    ]);
  }, []);

  const handleMenuClick = (val) => {
    handleTopMenuClick();
    setAnchorAl(val);

    if (val === "Dashboard") navigate("/dashboard/default");
    else if (val === "Applications") navigate("/ap/job-applicants");
    else if (val === "Match Analysis") navigate("/ma/match-analysis");
    else navigate("/jp/job-positions");

    dispatcher({
      type: MENU_SELECT,
      payload: { menuItem: val },
    });
  };

  return (
    <>
      {tourLocation === 6 && (
        <Joyride
          steps={tourSteps}
          continuous
          showSkipButton
          styles={{ options: { zIndex: 10000 } }}
        />
      )}

      <Box sx={{flexGrow:1,display: {md: "flex" }}}>

        {/* 🔹 MENU-DEEP ICON */}
        {/* <Grid item sx={{ mr: 3 }}>
          <IconButton
            className="menu-deep"
            onClick={(e) => setDeepMenuAnchor(e.currentTarget)}
            sx={{ mt: 1, color: theme.palette.common.black }}
          >
            <IconMenuDeep
              size={26}
              style={{ transform: "scaleX(-1)" }}
            />
          </IconButton>


          <Menu
            anchorEl={deepMenuAnchor}
            open={Boolean(deepMenuAnchor)}
            onClose={() => setDeepMenuAnchor(null)}
          >
            <MenuItem onClick={() => { handleMenuClick("Job Positions"); setDeepMenuAnchor(null); }}>
              <IconBriefcase size={18} style={{ marginRight: 8 }} />
              Job Positions
            </MenuItem>

            <MenuItem onClick={() => { handleMenuClick("Applications"); setDeepMenuAnchor(null); }}>
              <IconUsers size={18} style={{ marginRight: 8 }} />
              Applications
            </MenuItem>

            <MenuItem onClick={() => { handleMenuClick("Match Analysis"); setDeepMenuAnchor(null); }}>
              <IconChartHistogram size={18} style={{ marginRight: 8 }} />
              Match Analysis
            </MenuItem>
          </Menu>
        </Grid> */}

        <Grid item
          >
          <IconButton
            className="menu-deep"
            onClick={(e) => setDeepMenuAnchor(e.currentTarget)}
            sx={{
              color: theme.palette.common.black
            }}
          >
            <IconMenuDeep size={26} />
          </IconButton>

          <Menu
            anchorEl={deepMenuAnchor}
            open={Boolean(deepMenuAnchor)}
            onClose={() => setDeepMenuAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={() => { handleMenuClick("Job Positions"); setDeepMenuAnchor(null); }}>
              <IconBriefcase size={18} style={{ marginRight: 8 }} />
              All Job Positions
            </MenuItem>

            <MenuItem onClick={() => { handleMenuClick("Applications"); setDeepMenuAnchor(null); }}>
              <IconUsers size={18} style={{ marginRight: 8 }} />
              All Applications
            </MenuItem>

            <MenuItem onClick={() => { handleMenuClick("Match Analysis"); setDeepMenuAnchor(null); }}>
              <IconChartHistogram size={18} style={{ marginRight: 8 }} />
              All Match Analysis
            </MenuItem>
          </Menu>
        </Grid>


        {/* 🔹 REST OF MENUS */}
        {MenuSet
          .filter((page) => !hiddenMenus.includes(page))
          .map((page) => (
            <Grid item sx={{ mr: 3 }} key={page}>
              {page !== 'Settings' ? (
                <Fab
                  variant="extended"
                  size="small"
                  sx={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    my: 1,
                    color: theme.palette.common.black,
                    ml: 1,
                    textTransform: "uppercase",
                    fontWeight: "bold",
                  }}
                  onClick={() => handleMenuClick(page)}
                  className={`${page.toLowerCase().replace(/\s+/g, '-')}-menu`}
                >
                  <Typography
                    color={menuItem === page ? AppBarTextColor().selectColor : "inherit"}
                    variant="h5"
                    fontWeight="bold"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                  >
                    {page === 'Dashboard' && <DashboardIcon sx={{ fontSize: 22 }} />}
                    {page}
                  </Typography>
                </Fab>
              ) : (
                <HiredrateSettingDropDown
                  keyName={page}
                  selectMenu={anchorAl}
                  selectTrigger={(eve) => eve !== 'NS' && handleMenuClick(page)}
                />
              )}
            </Grid>
          ))}
      </Box>
    </>
  );
};

export default HiredrateAppBar;
